import { t, useI18n } from "@bookingcom/lingojs-react";
import usePointOfSale from "../../../../../../../hooks/usePointOfSale.js";
import useGetUrlParams from "../../../../../../../hooks/useGetUrlParams.js";
import { PRE_OPTED_ANCILLARIES_QUERY_PARAMS } from "../../../../../../../constants.js";
import { isOfMetaOrigin } from "../../../../../../../utils/marketing-url-params.js";
const useExtraProductsInfoController = (flight) => {
    const i18n = useI18n();
    const pointOfSale = usePointOfSale();
    const { getUrlParam } = useGetUrlParams();
    const { ancillaries, includedProducts, travellers } = flight;
    const { checkedInBaggage, cabinBaggagePerTraveller, flexibleTicket, travelInsurance } = ancillaries ?? {};
    const isFlexTicket = !!getUrlParam(PRE_OPTED_ANCILLARIES_QUERY_PARAMS.flexibleTicket);
    const isCfarTicket = !!getUrlParam(PRE_OPTED_ANCILLARIES_QUERY_PARAMS.cancelForAnyReason);
    const showInsurance = pointOfSale !== "gb" && !!travelInsurance;
    const checkedInBaggageOption = checkedInBaggage?.options[0];
    const showExtraBaggage = Boolean(cabinBaggagePerTraveller || checkedInBaggage);
    const checkedBaggageHasGeniusDeal = checkedInBaggageOption?.priceBreakdown?.bcomPricingItems?.some((item) => item.itemType === "GENIUS_CHECKED_BAG");
    const showFlexibleTicket = !!flexibleTicket &&
        !flexibleTicket?.priceBreakdown?.bcomPricingItems?.some((item) => item.itemType === "GENIUS_FLEXTICKET");
    const showNonBaggageItems = showInsurance || showFlexibleTicket;
    const showLoadingPrice = isOfMetaOrigin();
    const data = {
        inconsistentCabinBaggageInfo: showExtraBaggage && includedProducts,
        cabinBaggagePerTraveller: showExtraBaggage && cabinBaggagePerTraveller,
        checkedInBaggage: showExtraBaggage && !checkedBaggageHasGeniusDeal && checkedInBaggageOption,
        flexTicket: showFlexibleTicket && !(isFlexTicket || isCfarTicket) && flexibleTicket,
        insurance: pointOfSale !== "gb" && travelInsurance
    };
    const items = Object.values(data).filter((item) => !!item);
    return {
        header: i18n.trans(!showExtraBaggage || showNonBaggageItems ? t("flights_apex_fd_extras_headline") : t("flights_extra_baggage_title")),
        subheader: showNonBaggageItems && i18n.trans(t("flights_apex_fd_extras_sub_heading")),
        hasData: items.length > 0,
        ancillaries,
        showLoadingPrice,
        travellers,
        ...data
    };
};
export default useExtraProductsInfoController;
